import {ECustomerOrganizationStatus, ECustomerUpdateStatus} from '@app/shared/enums/header.enum';
import {ICustomerProfileState, IHeaderState} from '@app/shared/models/header.model';
import {createReducer, on} from '@ngrx/store';
import {
  getCustomerProfileSuccess,
  loadCustomerOrganizationSuccess,
  loadOrdersOnOrganizationChange,
  resetUpdateCustomerProfileStatus,
  setCustomerOrganization,
  setCustomerOrganizationStatus,
  setCustomerOrganizationStatusFromHeaderEffect,
  setUpdateCustomerProfileFailure,
  setUpdateCustomerProfileSuccess,
} from './header.action';

const initialState: IHeaderState = {
  customerProfileState: null,
  accountStatus: ECustomerOrganizationStatus.Default,
  customerOrganization: null,
  updateCustomerStatus: ECustomerUpdateStatus.Default,
  isOrganizationChanged: false,
};

export const headerReducer = createReducer(
  initialState,
  on(getCustomerProfileSuccess, (state, {customerProfileState}) => ({
    ...state,
    customerProfileState: customerProfileState,
  })),
  on(setCustomerOrganizationStatus, setCustomerOrganizationStatusFromHeaderEffect, (state, {accountStatus}) => ({
    ...state,
    accountStatus: accountStatus,
  })),
  on(setCustomerOrganization, loadCustomerOrganizationSuccess, (state, {organization}) => ({
    ...state,
    customerOrganization: organization,
  })),
  on(setUpdateCustomerProfileSuccess, (state, {customerProfileState, updateCustomerStatus}) => ({
    ...state,
    customerProfileState: {
      ...state.customerProfileState,
      phoneNumber: customerProfileState.phoneNumber,
      prefixPhoneNumber: customerProfileState.prefixPhoneNumber,
    } as ICustomerProfileState,
    updateCustomerStatus: updateCustomerStatus,
  })),
  on(setUpdateCustomerProfileFailure, (state, {updateCustomerStatus}) => ({
    ...state,
    updateCustomerStatus: updateCustomerStatus,
  })),
  on(resetUpdateCustomerProfileStatus, state => ({
    ...state,
    updateCustomerStatus: ECustomerUpdateStatus.Default,
  })),
  on(loadOrdersOnOrganizationChange, (state, {isOrganizationChanged}) => ({
    ...state,
    isOrganizationChanged: isOrganizationChanged,
  }))
);
